import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Notification, useToaster } from "rsuite";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Header from "../../comman/Header-copy"
import CustomLoader from "../../comman/Loader/CustomLoader";
import List from "./List";
import SearchBar from "../../comman/Search/SearchBar";
import Topbar from "../../comman/Topbar"
import ListFilters from "../../comman/ListFilters";
import DetailModal from "./DetailModal";
import { Link } from 'react-router-dom';
import CampaignDetailModal from "../campaigns/CampaignDetailModal";
import { Auth } from "../../../Contexts/AuthContext";
import Footer from "../../comman/Footer";



const MyPosts = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [campaignTasksRequests, setCampaignTasksRequests] = useState([]);
    const { setFavoriteCounts } = useContext(Auth);
    const [selectedCampaignTasksRequest, setSelectedCampaignTasksRequest] = useState();
    const [searchCampaign, setSearchCampaign] = useState();
    const [search, setSearch] = useState('');
    const [selectedCampaign, setSelectedCampaign] = useState();
    const [showCampignDetailModal, setShowCampignDetailModal] = useState();
    const [selectedSocialPosts, setSelectedSocialPost] = useState({});
    const [filterStatus, setFilterStatus] = useState('my_posts');
    const [filters, setFilters] = useState([]);
 

    const toaster = useToaster();
    useEffect(() => {
        getMyCampaignTasksRequests(filterStatus)



        const close = (e) => {
            if (e.keyCode === 27) {
                setShowModal(false);
                setShowCampignDetailModal(false);
            }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    }, [filterStatus])



    const getMyCampaignTasksRequests = (filterStatus) => {
        let config = {
            url: ApiUrl.getMyCampaignTasksRequests,
            method: 'POST',
            body: {
                status: filterStatus
            }
        }
        setIsLoading(true);
        APIRequest(
            config,
            res => {

                setCampaignTasksRequests(res?.data);
                setSearchCampaign(res?.data);
                setFilters([
                    {
                        name: 'My Tasks',
                        value: 'my_posts',
                        count: res?.post_count,
                        is_active: filterStatus === 'my_posts' ? true : false,
                    },
                    {
                        name: 'Action Required',
                        value: 'action_required',
                        count: res?.action_required_count,
                        is_active: filterStatus === 'action_required' ? true : false,
                    },

                    {
                        name: 'Pending Client Review',
                        value: 'pending_client_review',
                        count: res?.pending_client_review_count,
                        is_active: filterStatus === 'pending_client_review' ? true : false,
                    },
                    
                    // {
                    //     name: 'Insights',
                    //     value: 'insights',
                    //     count: res?.insights_count,
                    //     is_active: filterStatus === 'insights' ? true : false,
                    // }
                ]);
                setSearch('');
                setIsLoading(false);

            },

            err => {
                setIsLoading(false);
                alert('SERVER ERROR');
            }

        )
    }


    const sharePostWithBrand = () => {
        let hasError = false;
        selectedCampaignTasksRequest?.live_posts.forEach((post) => {    
            if (selectedSocialPosts[post?.id] === undefined) {
                toaster.push(<Notification type='warning' header="Warning"  >{`Please select post for ${post?.platform}`}</Notification>, {
                    placement: 'topEnd'
                });
                hasError = true;
                return;
            }
        });

        if (!hasError) {
            setIsLoading(true);
            let config = {
                url: ApiUrl.updatedCampaignStatus,
                method: 'POST',
                body: {
                    campaign_task_request_id: selectedCampaignTasksRequest?.data?.id,
                    status: "Link posted",
                    posts: selectedSocialPosts

                }
            }

            APIRequest(
                config,
                res => {
                    setIsLoading(false);
                    toaster.push(<Notification type='success' header="Sccess"  >{res.message}</Notification>, {
                        placement: 'topEnd'
                    });
                    setShowModal(false);
                    getMyCampaignTasksRequests(filterStatus);

                },
                err => {
                    setIsLoading(false);
                }

            )
        }
    }

    const getCampaignTaskRequestDetails = (ctr_id) => {
        let config = {
            url: `${ApiUrl.getCampaignTasksDetails}/${ctr_id}`,
            method: 'GET',
            body: {}
        }
        setIsLoading(true);
        APIRequest(
            config,
            res => {
                setSelectedCampaignTasksRequest(res);
                setIsLoading(false);
                setShowModal(true);

            },

            err => {
                setIsLoading(false);
                alert('SERVER ERROR');
            }

        )
    }


    const searchOnChange = (value) => {

        const val = value.toLowerCase();
        const finalVal = campaignTasksRequests?.filter((v) => (v?.campaign.campaign_title.toLowerCase()?.includes(val) || v?.campaign.brand.toLowerCase().includes(val)));
        setSearchCampaign(finalVal);
        setSearch(value)


    }

    const handleSelectedSocialPosts = (name, value) => {
        const post = {
            ...selectedSocialPosts,
            [name]: value
        }
        setSelectedSocialPost(post);
    }

    const markFavorite = (id) => {
        let config = {
            url: `${ApiUrl.markFavorite}/${id}`,
            method: 'GET',
            body: {}
        }
        APIRequest(
            config,
            res => {
                setFavoriteCounts(res?.total_favorite_counts);
                localStorage.setItem('favCounts', res?.total_favorite_counts);

                setSelectedCampaign({ ...selectedCampaign, is_favorite: !selectedCampaign.is_favorite })
            },

            err => {

                setIsLoading(false);
    
            }

        )
    }
    const onApplyForCampaign = () => {
        setShowCampignDetailModal(false);

    }

    const handleShowSocialPlatform = (range) => {
        let toggaleValue = false;
        if (range?.selected === undefined || range?.selected === false) {
            toggaleValue = true;
        }
        const updatedRange = { ...range, selected: toggaleValue };
        const updatedRangeArr = selectedCampaign?.allocatedBudget?.map(sb => sb?.soical_paltfom_id === updatedRange?.soical_paltfom_id ? updatedRange : sb);
        setSelectedCampaign({ ...selectedCampaign, allocatedBudget: updatedRangeArr });
       
    }

  

    return (
        <>
             <div className="min-h-[100vh]">
                <Header />
                <Topbar />
                <CustomLoader visible={isLoading} />
                <SearchBar  search={search} title={'My Posts'} searchOnChange={(val)=>searchOnChange(val)} />
                <ListFilters
                    filters={filters}
                    onChangeFilter={(status) => { setSelectedCampaignTasksRequest(); setFilterStatus(status); }}
                />
                 {console.log("filter :" ,filters)}

                <List data={searchCampaign}
                    filterStatus={filterStatus}
                    openCampaignDetails={(item) => { setSelectedCampaign(item); setShowCampignDetailModal(true) }}
                    onSelectCampaignTaskRequest={(item) => { getCampaignTaskRequestDetails(item?.id); }}
                />
                {!isLoading && (
                    <>
                            <DetailModal
                            item={selectedCampaignTasksRequest?.data}
                            live_posts={selectedCampaignTasksRequest?.live_posts}
                            showModal={showModal}
                            filterStatus={filterStatus}
                            setShowModal={() => { setShowModal(!showModal); getMyCampaignTasksRequests(filterStatus); }}
                            selectedSocialPosts={selectedSocialPosts}
                            openCampaignDetails={(item) => { setShowModal(false); setSelectedCampaign(item); setShowCampignDetailModal(true) }}
                            setSelectedSocialPost={(name, value) => { handleSelectedSocialPosts(name, value) }}
                            sharePostWithBrand={sharePostWithBrand} />

                                <CampaignDetailModal item={selectedCampaign}
                                markFavorite={(id) => { markFavorite(id) }}
                                showModal={showCampignDetailModal} setShowModal={() => { setShowCampignDetailModal(!showCampignDetailModal) }}
                                applyForCampaign={(item) => { onApplyForCampaign() }}
                                setShowSocialPlatform={(range) => handleShowSocialPlatform(range)}
                                />
                    </>
                )}
                 {/* {console.log("socialPlatform :" , socialPlatform)} */}
                
            </div>
          
        
            <Footer colorClass="footerColor" clas="footer2" />
           
        </>
    );
}
export default MyPosts;